import { render, staticRenderFns } from "./SettingsIndexFieldSelection.vue?vue&type=template&id=19cbfbbb&"
import script from "./SettingsIndexFieldSelection.vue?vue&type=script&lang=js&"
export * from "./SettingsIndexFieldSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports